module.exports = __webpack_public_path__ + "static/media/input.818bc1da.png";